import { useState } from "react";
import AuthApi from "../../../api/auth";
import errorHandler from "../../../errors/errorHandler";
import { InvalidCredentialsError } from "../../../errors/authErrors";

// TODO - Add Data Validation!
export function useLogin(hospitalId, onSuccess) {
  const [loading, setLoading] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [phase, setPhase] = useState("login");
  const [otpEmail, setOtpEmail] = useState(null);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState(null);

  const handleMultipleLoginAttempts = () => {
    const nextAttempts = loginAttempts + 1;
    setLoginAttempts(nextAttempts);

    if (nextAttempts >= 3) {
      setIsBlocked(true);
      setErrorMessage(
        "Your user has been blocked. Please contact our support."
      );
    }
  };

  const submit = async ({ email, password }) => {
    if (isBlocked) return;

    try {
      setLoading(true);
      setErrorMessage(null);
      const result = await AuthApi.login({ email, password, hospitalId });

      if (result?.otpRequired) {
        setOtpEmail(result.email || email);
        setPhase("otp");
        return;
      }

      onSuccess();
    } catch (error) {
      if (error instanceof InvalidCredentialsError) {
        handleMultipleLoginAttempts();
      }
      // TODO: replace with centralized error UI
      errorHandler.handleErrorAlert(error);
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    if (!otpEmail) return;

    try {
      setOtpLoading(true);
      setOtpError(null);
      await AuthApi.requestOtp({ email: otpEmail, hospitalId });
    } catch (error) {
      const msg = error.response?.data?.message || "Failed to resend code.";
      setOtpError(msg);
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyOtp = async (otpCode) => {
    if (!otpEmail || !otpCode) return;

    try {
      setOtpLoading(true);
      setOtpError(null);
      await AuthApi.verifyOtp({ email: otpEmail, hospitalId, otpCode });
      onSuccess();
    } catch (error) {
      const msg = error.response?.data?.message || "Invalid or expired code.";
      setOtpError(msg);
    } finally {
      setOtpLoading(false);
    }
  };

  return {
    submit,
    loading,
    isBlocked,
    errorMessage,
    phase,
    otpEmail,
    otpLoading,
    otpError,
    resendOtp,
    verifyOtp,
  };
}